(function() {
    'use strict';
    angular
        .module('MW.ContactManager.OnEnterAction', [])
        .directive('onEnterAction', function () {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    element.on('keypress', function(event) {
                        if(event.which === 13) {
                            scope.$eval(attrs.onEnterAction);

                            event.preventDefault();
                        }
                    });

                    scope.$on('$destroy', function() {
                        element.off('keypress');
                    });
                }
            };
        });
}());
